import { createAction, props } from '@ngrx/store';
import { ReducerSections, ReducerStatuses } from '../models/reducer';
import { TrainingActions } from '../models/training.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ICurrentSection, ITrainingStage } from '../../../shared/services/training/training.type';
import { IPaginationFilter } from '../models/filters.model';
import { SectionsListModes } from '../../../shared/enums';
import { ITrainingSearchResultElement } from '../../../shared/services/training/training.type';
import { ITrainingUserPositionGroup } from 'src/app/shared/services/user/user.type';

export const getSectionsList = createAction(
  `${ReducerSections.TRAINING} ${TrainingActions.getSectionsList}`,
);

export const getSectionsListSuccess = createAction(
  `${ReducerSections.TRAINING} ${TrainingActions.getSectionsList} ${ReducerStatuses.SUCCESS}`,
  props<{ sectionsList: ITrainingUserPositionGroup[] }>(),
);

export const getSectionsListFailed = createAction(
  `${ReducerSections.TRAINING} ${TrainingActions.getSectionsList} ${ReducerStatuses.FAILED}`,
  props<{ error: HttpErrorResponse }>(),
);

export const getSearchResultsFiles = createAction(
  `${ReducerSections.TRAINING} ${TrainingActions.searchResultsFiles}`,
  props<{ filters: IPaginationFilter }>(),
);

export const getSearchResultsFilesSuccess = createAction(
  `${ReducerSections.TRAINING} ${TrainingActions.searchResultsFiles} ${ReducerStatuses.SUCCESS}`,
  props<{
    trainingFilesList: ITrainingSearchResultElement[];
    currentMode: SectionsListModes;
    resetData: boolean;
  }>(),
);

export const getSearchResultsFilesFailed = createAction(
  `${ReducerSections.TRAINING} ${TrainingActions.searchResultsFiles} ${ReducerStatuses.FAILED}`,
  props<{ error: HttpErrorResponse }>(),
);

export const getCurrentSectionInfo = createAction(
  `${ReducerSections.TRAINING} ${TrainingActions.getCurrentSectionInfo}`,
  props<{ sectionId: number }>(),
);

export const getCurrentSectionInfoSuccess = createAction(
  `${ReducerSections.TRAINING} ${TrainingActions.getCurrentSectionInfo} ${ReducerStatuses.SUCCESS}`,
  props<{ section: ICurrentSection }>(),
);

export const getCurrentSectionInfoFailed = createAction(
  `${ReducerSections.TRAINING} ${TrainingActions.getCurrentSectionInfo} ${ReducerStatuses.FAILED}`,
  props<{ error: HttpErrorResponse }>(),
);

export const getCurrentStage = createAction(
  `${ReducerSections.TRAINING} ${TrainingActions.getCurrentStage}`,
  props<{ stageId: number }>(),
);

export const getCurrentStageSuccess = createAction(
  `${ReducerSections.TRAINING} ${TrainingActions.getCurrentStage} ${ReducerStatuses.SUCCESS}`,
  props<{ stage: ITrainingStage }>(),
);

export const getCurrentStageFailed = createAction(
  `${ReducerSections.TRAINING} ${TrainingActions.getCurrentStage} ${ReducerStatuses.FAILED}`,
  props<{ error: HttpErrorResponse }>(),
);

export const clearTrainingData = createAction(
  `${ReducerSections.TRAINING} ${TrainingActions.clearSectionsData}`,
);

export const clearStageData = createAction(
  `${ReducerSections.TRAINING} ${TrainingActions.clearStageData}`,
);

export const clearSectionData = createAction(
  `${ReducerSections.TRAINING} ${TrainingActions.clearSectionData}`,
);
